import React from 'react'
import { useParams } from 'react-router-dom'
import SideBar from '../../SideBar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router-dom'

const QuoteDetails = () => {
  const { quoteType } = useParams()
  const navigate = useNavigate()
  const getTitle = () => {
    switch (quoteType) {
      case 'basic':
        return 'Basic Quote Details'
      case 'enhanced':
        return 'Enhanced Quote Details'
      case 'expensive':
        return 'Expensive Quote Details'
      default:
        return 'Quote Details'
    }
  }

  return (
    <div className="w-full">
      {/* Main Content Layout */}
      <div className="flex flex-col lg:flex-row max-w-[90rem] mx-auto lg:space-x-6 mt-24">
        <main className="w-full text-sas-dark">
          <div className='flex space-x-8'>
            <div className='w-full lg:w-1/3 space-y-4'>
              <div className="bg-slate-800 text-white p-6 rounded-xl relative overflow-hidden">
                {/* Decorative Dot Background */}
                <div className="absolute inset-0 bg-[radial-gradient(#ffffff1a_1px,transparent_1px)] [background-size:16px_16px] opacity-10 pointer-events-none"></div>

                {/* Content */}
                <div className="relative z-10 space-y-2">
                  <div className="flex items-center justify-between">
                    <div className="text-2xl font-bold">Enhanced Plan</div>
                    <div className="rounded-full px-4 py-1.5 text-xs bg-white text-slate-700 font-semibold">
                      Exceptional
                    </div>
                  </div>

                  <div className="text-lg font-semibold tracking-wide">Ultimate Protection. Complete Peace of Mind.</div>
                </div>
              </div>
              <div className='border rounded-lg p-4'>
                <div className="text-sm text-sas-dark">
                  Our Enhanced Plan is designed for schools that demand more. From day-one absences to compassionate leave,
                  experience the highest level of cover — with zero compromises.
                </div>
                <ul className="mt-4 space-y-1 text-sm text-sas-dark list-inside list-none">
                  <li><FontAwesomeIcon icon={faCheck} className="text-sas-primary mr-2" /> Unlimited sickness and injury cover</li>
                  <li><FontAwesomeIcon icon={faCheck} className="text-sas-primary mr-2" /> Extended support for phased returns</li>
                  <li><FontAwesomeIcon icon={faCheck} className="text-sas-primary mr-2" /> Full protection for unexpected events</li>
                  <li><FontAwesomeIcon icon={faCheck} className="text-sas-primary mr-2" /> Priority claim handling & support</li>
                </ul>
              </div>
              {/* Payment Options */}
              <div className='mt-4 border rounded-lg p-4'>
                <h3 className="text-lg font-semibold mb-2">Choose a Payment Option</h3>
                <div className="flex gap-4 flex-wrap">
                  <button className="border border-sas-primary text-sas-primary px-4 py-2 rounded-md hover:bg-sas-primary hover:text-sas transition">
                    Pay Annually
                  </button>
                  <button className="border border-sas-primary text-sas-primary px-4 py-2 rounded-md hover:bg-sas-primary hover:text-sas transition">
                    Pay Termly
                  </button>
                  <button className="border border-sas-primary text-sas-primary px-4 py-2 rounded-md hover:bg-sas-primary hover:text-sas transition">
                    Pay Monthly
                  </button>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-2/3">
              <div className="bg-white border rounded-lg p-6 shadow-sm">
                <div className='flex items-center justify-between'>
                  <h2 className="text-3xl font-bold text-sas-primary mb-6">{getTitle()}</h2>
                  {/* Upgrade Plan */}
                  <div className="mb-6">
                    <button
                      className="bg-sas hover:bg-sas-dark text-white px-4 py-2 rounded-md shadow-md transition-all"
                    >
                      Upgrade Plan
                    </button>
                  </div>
                </div>
                <div className="text-lg font-semibold text-slate-800 mb-1">Your Selected Plan:</div>
                <p className="mb-4 text-slate-600">
                  You’ve chosen the <strong className="text-sas-primary capitalize">{quoteType}</strong> quote for the upcoming academic year.
                </p>

                {/* Quote Details */}
                <div className="grid grid-cols-2 gap-y-3 text-sm text-gray-700 mb-6">
                  <div><strong>Quote Reference:</strong> SAS999999-1109590</div>
                  <div><strong>Policy Type:</strong> SAS Policy</div>
                  <div><strong>Premium:</strong> £10,162.37 <span className="text-xs text-gray-500">(Inc. IPT)</span></div>
                  <div><strong>Start Date:</strong> Not Specified</div>
                  <div><strong>End Date:</strong> Not Specified</div>
                  <div><strong>Staff Covered:</strong> Teachers: 20.0 FTE / Test: 30.0 FTE</div>
                  <div><strong>Daily Benefit:</strong> £100 (Teachers), £30 (Test)</div>
                  <div><strong>Excess:</strong> 3 Days</div>
                  <div><strong>Benefit Days:</strong> 190 Days</div>
                  <div><strong>Stress Days:</strong> 190 Days</div>
                  <div><strong>Maternity Cover:</strong> £2,500.00</div>
                </div>

                <p className="text-sm text-sas-dark mt-4">As part of this policy, your school gains access to:</p>
                <ul className="mt-2 space-y-1 text-sm text-sas-dark list-disc list-inside grid grid-cols-2 gap-y-1">
                  <li>Unlimited Counselling</li>
                  <li>GP Phone and Video Consultations</li>
                  <li>Menopause Support</li>
                  <li>Leadership Supervision</li>
                  <li>Occupational Health Support</li>
                  <li>24/7 Access via App</li>
                  <li>Private Medical Operations</li>
                  <li>Flu Jabs</li>
                  <li>Annual Health Screens</li>
                  <li>...and more</li>
                </ul>
                <div className='pt-2'>
                  <h3 className="text-lg font-semibold my-2">Additional Options</h3>
                  <ul>
                    <li><FontAwesomeIcon icon={faCheck} className="text-sas-primary mr-2" /> Stress related absences</li>
                    <li><FontAwesomeIcon icon={faCheck} className="text-sas-primary mr-2" /> Maternity/Parental leave</li>
                  </ul>
                </div>
              </div>
              <div className="bg-white border rounded-xl shadow-md p-6 mt-8">
                <h3 className="text-2xl font-bold text-sas-primary mb-4">Quote Breakdown</h3>

                {/* Quote Summary Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-800">
                  <div className="flex justify-between border-b py-2">
                    <span className="font-semibold">Quote Reference:</span>
                    <span className="text-sas-dark">SAS999999-1109590</span>
                  </div>
                  <div className="flex justify-between border-b py-2">
                    <span className="font-semibold">Policy Type:</span>
                    <span className="text-sas-dark">SAS Policy</span>
                  </div>
                  <div className="flex justify-between border-b py-2">
                    <span className="font-semibold">Annual Premium:</span>
                    <span className="text-sas-dark">£10,162.37 <span className="text-xs text-gray-500">(Inc. IPT)</span></span>
                  </div>
                  <div className="flex justify-between border-b py-2">
                    <span className="font-semibold">Start Date:</span>
                    <span className="text-sas-dark">1st April 2025</span>
                  </div>
                  <div className="flex justify-between border-b py-2">
                    <span className="font-semibold">End Date:</span>
                    <span className="text-sas-dark">31st March 2026</span>
                  </div>
                  <div className="flex justify-between border-b py-2">
                    <span className="font-semibold">Staff Covered:</span>
                    <span className="text-sas-dark">Teachers: 20.0 FTE / Test: 30.0 FTE</span>
                  </div>
                  <div className="flex justify-between border-b py-2">
                    <span className="font-semibold">Daily Benefit:</span>
                    <span className="text-sas-dark">£100 (Teachers), £30 (Test)</span>
                  </div>
                  <div className="flex justify-between border-b py-2">
                    <span className="font-semibold">Excess:</span>
                    <span className="text-sas-dark">3 Days</span>
                  </div>
                  <div className="flex justify-between border-b py-2">
                    <span className="font-semibold">Benefit Days:</span>
                    <span className="text-sas-dark">190 Days</span>
                  </div>
                  <div className="flex justify-between border-b py-2">
                    <span className="font-semibold">Stress Days:</span>
                    <span className="text-sas-dark">190 Days</span>
                  </div>
                  <div className="flex justify-between border-b py-2">
                    <span className="font-semibold">Maternity Cover:</span>
                    <span className="text-sas-dark">£2,500.00</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='mt-12'>
            <button onClick={() => navigate('/sai/quotes')} className='flex justify-center items-center text-white bg-sas rounded-lg shadow-md px-4 py-2 cursor-pointer hover:bg-sas-dark  transition-all'>
              <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
              <span>Go Back</span>
            </button>
          </div>
        </main>
      </div>
    </div>
  )
}

export default QuoteDetails
